/**
 * Section Titles Data
 * Contains section titles and subtitles for different pages and components
 */

export const sectionTitles = {
  news: {
    title: "Latest Stories",
    subtitle: "Discover fascinating stories from the world of music legends"
  },
  artists: {
    title: "Our Artists",
    subtitle: "Browse legendary artists and explore their stories"
  },
  concerts: {
    title: "Upcoming Concerts",
    subtitle: "Don't miss these legendary performances"
  },
  artistCTA: {
    title: "Discover More Legendary Artists",
    subtitle: "Explore detailed profiles, rare photos, and stories."
  },
  newsletter: {
    title: "Stay Updated",
    subtitle: "Get the latest music news and stories delivered to your inbox"
  },
  concertAlert: {
    title: "Never Miss a Concert",
    titleIcon: "bi bi-bell",
    subtitle: "Get notified when your favorite artists announce new concerts in your area",
    privacyText: "We'll only send you concert alerts for artists you're interested in."
  },
  exploreCTA: {
    title: "Ready to Explore Music History?",
    subtitle: "Join thousands of music lovers discovering rare stories, exclusive content, and the legends that shaped our world.",
    buttons: [
      {
        to: "/artists",
        text: "Start Exploring",
        icon: "bi bi-music-note",
        variant: "btn-warning"
      }
    ]
  }
};

